/* eslint-disable react/jsx-props-no-spreading */
import React from 'react';
import PropTypes from 'prop-types';
import { Create, Edit, SimpleForm } from 'react-admin';
import UserForm from './UserForm';
import rolesEnum from '../../enums/user-roles.enum';
import courseStatus from '../../enums/course-status.enum';

const UserDetail = (props) => {
  const { actionType } = props;
  return (
    <>
      {actionType === 'edit' ? (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Edit {...props}>
          <SimpleForm>
            <UserForm roles={rolesEnum} status={courseStatus} />
          </SimpleForm>
        </Edit>
      ) : (
        // eslint-disable-next-line react/jsx-props-no-spreading
        <Create {...props}>
          <SimpleForm>
            <UserForm roles={rolesEnum} status={courseStatus} />
          </SimpleForm>
        </Create>
      )}
    </>
  );
};

UserDetail.propTypes = {
  actionType: PropTypes.string,
};

UserDetail.defaultProps = {
  actionType: 'create',
};

export default UserDetail;
